module.exports = __webpack_public_path__ + "static/media/aquisition.8adeea09.svg";